import React from 'react'
import styled from 'styled-components'
import { fondo } from '../../../components/UI/variables'
import FormStudent from "../../../components/FormStudent"
import Titulo2 from "../../../components/Titulo2"

const StyledSection = styled.section`
  background-color: ${fondo};
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`
const StyledTitulo = styled(Titulo2)`
  margin-bottom: 50px;
`
const RegistroStudent = () => {
  return (
    <StyledSection >
      <StyledTitulo $naranja>Regístrate y encuentra tu habitación</StyledTitulo>
      <FormStudent/>
    </StyledSection>
  )
}

export default RegistroStudent